import ApiClient from './ApiClient'
import { withQuery } from '../../utils/urlParams'
import { formatDateParam } from '../../utils/dateHelpers'

class CrossStatisticsService {
  static getStatistics(formUrl, { variableId, questionId, startDate, endDate, statisticsType }) {
    return ApiClient.get(withQuery(`${formUrl}.json`, [
      ['variable_id', variableId],
      ['statistics_type', statisticsType],
      ['question_id', questionId],
      ['start_date', startDate],
      ['end_date', endDate]
    ]))
  }

  static savePreferences(url, formState) {
    return ApiClient.post(url, {
      variableId: formState.variableId,
      questionIds: formState.questionIds,
      startDate: formatDateParam(formState.startDate),
      endDate: formatDateParam(formState.endDate),
      displayMode: formState.displayMode,
      compareType: formState.compareType
    })
  }
}

export default CrossStatisticsService
